export default "__VITE_ASSET__ri_PbyHF__"